import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "g-page-loading"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("加载中...");

import TabBar from '@/components/TabBar.vue';
import { apiJsApiTicketGet } from '@/api/weixin';
import wx from 'weixin-js-sdk';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',

  setup(__props) {
    const store = useStore();
    const isLoading = computed(() => !(store.state.user.customerId > 0));
    const jssdkIsReady = ref(false);
    apiJsApiTicketGet({
      url: window.location.href
    }).then(res => {
      jssdkIsReady.value = false;
      const {
        appId,
        nonceStr,
        signature,
        timestamp
      } = res;
      const jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'hideMenuItems', 'showMenuItems'];
      wx.config({
        debug: false,
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList
      });
    });
    wx.error(res => {
      console.log('失败', res);
    });
    wx.ready(() => {
      jssdkIsReady.value = true;
    });
    return (_ctx, _cache) => {
      const _component_van_loading = _resolveComponent("van-loading");

      const _component_router_view = _resolveComponent("router-view");

      return _unref(isLoading) && !jssdkIsReady.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_loading, {
        size: "24px",
        vertical: ""
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      })])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_router_view), _withDirectives(_createElementVNode("div", null, [_createVNode(TabBar)], 512), [[_vShow, _ctx.$route.meta.isShowTabbar !== false]])], 64));
    };
  }

});